
import React from 'react';
import './OurStoryPage.css';


import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function OurStoryPage() {
  return (
    <>

      <Navbar />

      <section className="our-story-page">

        {/* HERO SECTION */}

      <div className="story-hero">

  <p className="story-tag">
    OUR STORY
  </p>

  <h1>
    More Than Just
    A Cleaning Service
  </h1>

  <span>
    Building opportunity, dignity,
    and cleaner spaces across Cape Town.
  </span>

</div>

        {/* STORY CONTENT */}

        <div className="story-section">

          <div className="story-container">

            <div className="story-box">

              <h2>How It Started</h2>

              <p>
                In a world where many go without work
                and some even without daily bread,
                myself and my spouse decided to become
                the change we wanted to see.
              </p>

              <p>
                That’s how Reasonable Services Company
                was born, an affordable mobile car wash
                and cleaning service with a purpose
                beyond profit.
              </p>

              <p>
                We are proudly based in Muizenberg,
                Cape Town, offering reliable and
                affordable services to homes,
                offices, and property owners who
                need quality work they can trust.
              </p>

              <h3>More Than Just A Service</h3>

              <p>
                Reasonable Services Company is built
                on dignity, opportunity, and community impact.
              </p>

              <p>
                Our team is small but powerful:
                three hardworking women from different families,
                including our hands-on manager who runs
                the business while I work remotely.
              </p>

              <p>
                These women were previously unemployed mothers
                with little to no income.
                Today, they earn honestly through consistent work,
                providing for their families with pride.
              </p>

            </div>

            <div className="story-box">

              <h2>How Your Booking Helps</h2>

              <p>
                Our pricing is simple and community-minded.
                Every service you book supports real families.
              </p>

              <p>
                From each small car wash or home clean,
                the income is shared between the team members
                doing the work, our manager who uses her own
                vehicle for transport, and the equipment
                and supplies needed to keep the business running.
              </p>

              <p>
                Even one booking can mean bread on the table,
                groceries for the week,
                and hope for families working hard
                to build a better future.
              </p>

              <h3>Our Mission</h3>

              <p>
                To provide affordable,
                high-quality mobile car wash and
                cleaning services while creating
                employment opportunities and strengthening
                our community one job at a time.
              </p>

              <p>
                When you hire Reasonable Services Company,
                you’re not just paying for a clean car
                or fresh home,
                you’re supporting hardworking women
                and helping families thrive.
              </p>

              <strong>
                Thank you for choosing us
                and being part of meaningful change.
              </strong>

            </div>

          </div>

        </div>

      </section>

      <Footer />

    </>
  );
}

export default OurStoryPage;


